import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { LegalApiService } from 'features/legal-documents/api/legal-api.service';
import { User } from 'types';

import { LegalQueryKeys } from './query-keys';

const { getLegalDocuments } = LegalApiService();

const getUserQuery = (
  id: string,
  options?: UseQueryOptions<User>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<User>;
  options?: UseQueryOptions<User>;
} => ({
  queryKey: LegalQueryKeys.detail(id),
  queryFn: ({ signal }) => getLegalDocuments(id, { config: { signal } }),
  ...options,
});

export const useGetLegalList = (id: string, options?: UseQueryOptions<any>) => {
  const { message } = App.useApp();

  return useQuery<any, Error>(
    getUserQuery(id, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    }),
  );
};
